export default "__VITE_ASSET__Dlqe3AKN__"